import styled from 'styled-components';
import { Text } from '@axiom/ui';

export const ShareLinkModalStyledText = styled(Text)`
  border-bottom: 1px solid ${({ theme }) => theme.text.subtle};
  width: 100%;
`;
